import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UsertokenService } from '@shared-angular/services/usertoken.service';
import { firstValueFrom } from 'rxjs';

const endInvalidRoute = async (router: Router) => {
  await router.navigate(["/", "403"]);
};

const getBotIdFromRedirect = (redirect: string): string | null => {
  const redirectPattern = /^\/bot\/([^/]+)\/[^/]+$/;
  const match = redirectPattern.exec(redirect);
  return match?.[1] ?? null;
};

export const botaccessGuard: CanActivateFn = async (route, _state) => {
  const router = inject(Router);
  const http = inject(HttpClient);
  const usertokenService = inject(UsertokenService);

  const accesstoken = route.queryParamMap.get("accesstoken");
  const target = route.queryParamMap.get("target");

  if (accesstoken == "" || accesstoken == null) {
    await endInvalidRoute(router);
    return false;
  }

  try {
    const result = await firstValueFrom(http.post<{ redirect: string, token: string }>("/api/accesstokeninfo", { accesstoken: accesstoken, target }));
    // persist=false: Token wird erst nach Bestaetigung des Datenschutzhinweises in BotBasedComponent persistiert
    usertokenService.setUserTokenAfterAuth(result.token, false);
    const botId = getBotIdFromRedirect(result.redirect);
    if (botId != null) {
      localStorage.setItem("passthrough", botId);
    }
    await router.navigate([result.redirect]);
    return false;
  } catch (_e) {
    console.error("Error validating access token");
  }

  await endInvalidRoute(router);
  return false;
};